var map = {
	"./logo-bookmark-2.svg": 6432,
	"./logo-bookmark-white.svg": 1931,
	"./logo-bookmark.svg": 3062,
	"./logo-chrome.svg": 8606,
	"./logo-firefox.svg": 1596,
	"./logo-opera.svg": 3807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 203;